module.exports = __webpack_public_path__ + "static/media/inServe.9b93d31b.svg";